import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const fetchImpersonatableUsers = async () => {
  const token = localStorage.getItem("token");
  const { data } = await axios.get(`${__API_URL__}/api/admin/impersonate/users/`, {
    headers: { Authorization: `Token ${token}` },
  });
  return data;
};

const useGetImpersonatableUsers = ({ enabled = true } = {}) => {
  return useQuery({
    queryKey: ["impersonatable-users"],
    queryFn: fetchImpersonatableUsers,
    enabled,
  });
};

export default useGetImpersonatableUsers;
